var image_upload_default = {
  "container": "iQ2Mu",
  "disabled": "sLeGW",
  "imageInput": "m-2c7",
  "overlay": "TMPO9",
  "text": "MdUCX",
  "shown": "g-whN",
  "hide": "_29e7S",
  "spinner": "YVD8p",
  "spin": "Xrbyu"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
